import {Element} from "react-scroll";
import {Container} from "reactstrap";
import React from "react";

function Footer(){
    return <div>
        <Element name="contact">
            <footer style={{backgroundColor: '#A2BA87', color: '#fff', padding: '15px 0 15px 0'}}>
                <Container>
                    <div className="text-center mt-4">
                        <div className="mb-3">
                            <a href="mailto:benjaminzonic@gmail.com" className="text-white mx-3">
                                <i className="bi bi-envelope"></i>
                            </a>
                            <a href="tel:+38761094357" className="text-white mx-3">
                                <i className="bi bi-telephone"></i>
                            </a>
                            <a href="https://www.facebook.com/ecofriendlydoo" target="_blank" rel="noreferrer"
                               className="text-white mx-3">
                                <i className="bi bi-facebook"></i>
                            </a>
                            <a href="https://www.instagram.com/ecofriendlydoo?igsh=ZWx6cHV6bGI1MTFn" target="_blank" rel="noreferrer"
                               className="text-white mx-3">
                                <i className="bi bi-instagram"></i>
                            </a>
                            <a href="https://maps.app.goo.gl/FPPfahXb4bGvQnQ49" target="_blank" className="text-white mx-3" rel="noreferrer">
                                <i className="bi bi-pin-map-fill"></i>
                            </a>
                        </div>
                        <p className="mb-0">&copy; {new Date().getFullYear()} Eco friendly.</p>
                    </div>
                </Container>
            </footer>
        </Element>
    </div>
}

export default Footer;